import axios from 'axios';

export const CMS_SITE_ID = '666500197875781';

export const __ctx = location.hostname === 'localhost' ? '/dev-api' : '';
const baseURL = __ctx;

const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // 当跨域请求时发送cookie
  timeout: 5000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    // do something before request is sent

    // config.headers['token'] = localStorage.token ? 'Bearer-' + localStorage.token : '';
    config.headers["Content-type"] = "application/json;charset=UTF-8";
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  response => {
    if(response.config.url == '/prod-api/api/anon/issue') {
      console.log('response',response);
      console.log('Response headers:', [...response.headers.entries()]);
    }
    const statusCode = response.status;
    const res = response.data;
    if (statusCode !== 200 || res === null) {
      return Promise.reject(res);
    } else {
      return Promise.resolve(res);
    }
  },
  error => {
    return Promise.reject(error);
  },
);

export default service;

